import { Check, Loader2 } from "lucide-react";
import { STATUS_LABELS } from "./shared";

const FLOW_STAGES = [
  "aguardando_indicacao",
  "aguardando_orcamento",
  "orcamento_enviado",
  "agendado",
  "em_execucao",
  "concluido",
];

const fmtTime = (iso) =>
  iso
    ? new Date(iso).toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" })
    : null;

export const DemandFlow = ({ status, history = [], createdAt }) => {
  const terminated = status === "cancelado" || status === "encerrado";
  const current = FLOW_STAGES.indexOf(status);

  const stageTime = (stage, i) => {
    const entries = history.filter((h) => h.status === stage);
    const at = entries.length
      ? entries[entries.length - 1].at
      : i === 0
        ? createdAt
        : null;
    return fmtTime(at);
  };

  const terminatedAt = fmtTime(
    [...history].reverse().find((h) => h.status === status)?.at
  );

  return (
    <div className="mt-4 rounded-xl bg-petrol p-5" data-testid="demand-flow">
      <div className="flex items-center justify-between">
        <p className="font-mono text-[0.62rem] font-semibold uppercase tracking-[0.22em] text-brand-400">
          Fluxo de demanda
        </p>
        <span className="inline-flex items-center gap-1.5 rounded-full border border-white/15 bg-white/5 px-2.5 py-0.5 font-mono text-[0.58rem] uppercase tracking-widest text-emerald-400">
          <span className="relative flex h-1.5 w-1.5">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" />
            <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-emerald-400" />
          </span>
          ao vivo
        </span>
      </div>

      {terminated ? (
        <div className="mt-4 flex items-center gap-3 rounded-lg border border-white/10 bg-white/5 px-4 py-3">
          <span
            className={`h-2 w-2 rounded-full ${status === "cancelado" ? "bg-red-400" : "bg-slate-400"}`}
          />
          <p className="text-sm text-white/70">
            Esta demanda foi{" "}
            <strong className="text-white">{STATUS_LABELS[status].toLowerCase()}</strong>.
            {terminatedAt && (
              <span className="ml-2 font-mono text-[0.62rem] text-white/35">{terminatedAt}</span>
            )}
          </p>
        </div>
      ) : (
        <ul className="relative mt-4 space-y-2.5">
          <div className="absolute bottom-3 left-[9px] top-1.5 w-px bg-white/10" />
          {FLOW_STAGES.map((stage, i) => {
            const done = status === "concluido" || (current > -1 && i < current);
            const active = status !== "concluido" && i === current;
            const time = stageTime(stage, i);
            return (
              <li
                key={stage}
                className="relative flex items-center gap-3"
                data-testid={`flow-stage-${stage}`}
              >
                <span
                  className={`relative z-10 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border transition-colors duration-300 ${
                    done
                      ? "border-emerald-400 bg-emerald-400/15 text-emerald-400"
                      : active
                        ? "border-brand bg-brand text-white"
                        : "border-white/20 bg-petrol-800 text-white/25"
                  }`}
                >
                  {done ? (
                    <Check className="h-2.5 w-2.5" strokeWidth={3.5} />
                  ) : active ? (
                    <Loader2 className="h-2.5 w-2.5 animate-spin" strokeWidth={3.5} />
                  ) : (
                    <span className="h-1 w-1 rounded-full bg-current" />
                  )}
                </span>
                <span className="flex flex-col">
                  <span
                    className={`text-xs transition-colors duration-300 ${
                      done
                        ? "text-emerald-400"
                        : active
                          ? "font-semibold text-white"
                          : "text-white/30"
                    }`}
                  >
                    {STATUS_LABELS[stage]}
                  </span>
                  {time && (
                    <span
                      className="font-mono text-[0.6rem] text-white/35"
                      data-testid={`flow-stage-time-${stage}`}
                    >
                      {time}
                    </span>
                  )}
                </span>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};
